'use client'

import { useState } from 'react'
import { MdOutlineClose, MdOutlinePending } from 'react-icons/md'
import { useRolesAuth0 } from '../../../../auth/hooks/useRolesAuth0'
import { composeClasses } from '../../../../utils/src/strings'
import { OptionMenu, useGetMenuOptions } from '../hooks/useGetMenuOptions'
import { SidebarMobile } from './SidebarMenu'
import './MenuMobile.css'
import HardLink from '../../../components/hard-link/HardLink'

export const MenuMobile = ({ className }: { className?: string }) => {
  const { menuOptions, ICON_CLASSNAME } = useGetMenuOptions()

  const [showSideMenuOptions, setShowSideMenuOptions] = useState<
    boolean | null
  >(null)

  const leadManagementOption = menuOptions?.filter(
    (option) => option?.id === 'lead-management'
  )

  const leadLendingOption =
    leadManagementOption?.[0]?.subOptions?.filter(
      (subOption) => subOption?.id === 'lending'
    ) ?? []

  const sliceOptions =
    leadManagementOption && leadLendingOption
      ? [...leadManagementOption, ...leadLendingOption]
      : menuOptions?.slice(0, 4)

  const mobileBarOptions: OptionMenu[] = [
    ...sliceOptions,
    {
      id: 'all-options',
      icon: showSideMenuOptions ? (
        <MdOutlineClose className={ICON_CLASSNAME} />
      ) : (
        <MdOutlinePending className={ICON_CLASSNAME} />
      ),
      name: showSideMenuOptions ? 'Cerrar' : 'Más',
      isShow: true,
      isActive: Boolean(showSideMenuOptions),
      url: '',
      onClick: () => setShowSideMenuOptions(!showSideMenuOptions)
    }
  ]

  return (
    <>
      <div
        className={composeClasses(
          className,
          'fixed bottom-0 max-w-[100dvw] px-3 z-3 md:hidden w-full bg-surface-white border-t border-t-surface-strokes'
        )}
      >
        <div className="flex flex-row items-center justify-around gap-0 w-full">
          {mobileBarOptions?.map((option) => {
            const optionIsActive = () => {
              if (option?.id !== 'all-options' && showSideMenuOptions) {
                return false
              }

              return option?.isActive
            }

            if (!option?.url) {
              return (
                <button
                  type="button"
                  key={option?.id}
                  onClick={option?.onClick}
                  className={composeClasses(
                    'flex flex-col items-center justify-center py-1.5 w-full hover:bg-[#ced5e1] active:bg-[#DEE5F1] transition-colors duration-300 ease-in-out',
                    optionIsActive() ? 'text-primary' : 'text-secondary'
                  )}
                >
                  <span
                    className={composeClasses(
                      'w-9 h-9 rounded-xl border flex items-center justify-center [&>svg]:!min-h-[21px] [&>svg]:!min-w-[21px]',
                      optionIsActive()
                        ? 'bg-[#E8EDF5] border-primary'
                        : 'border-transparent'
                    )}
                  >
                    {option?.icon}
                  </span>
                  <span
                    className={composeClasses(
                      'text-body-xs',
                      optionIsActive()
                        ? 'text-primary font-semibold'
                        : 'text-secondary'
                    )}
                  >
                    {option?.mobileName || option?.name}
                  </span>
                </button>
              )
            }

            return (
              <HardLink
                href={option.url}
                key={option?.id}
                className={composeClasses(
                  'flex flex-col items-center justify-center py-1.5 w-full hover:bg-[#ced5e1] active:bg-[#DEE5F1] transition-colors duration-300 ease-in-out',
                  optionIsActive() ? 'text-primary' : 'text-secondary'
                )}
              >
                <span
                  className={composeClasses(
                    'w-9 h-9 rounded-xl border flex items-center justify-center [&>svg]:!min-h-[21px] [&>svg]:!min-w-[21px]',
                    optionIsActive()
                      ? 'bg-[#E8EDF5] border-primary'
                      : 'border-transparent'
                  )}
                >
                  {option?.icon}
                </span>
                <span
                  className={composeClasses(
                    'text-body-xs',
                    optionIsActive()
                      ? 'text-primary font-semibold'
                      : 'text-secondary'
                  )}
                >
                  {option?.mobileName || option?.name}
                </span>
              </HardLink>
            )
          })}
        </div>
      </div>
      <SidebarMobile
        isVisible={showSideMenuOptions}
        setShowSideMenuOptions={setShowSideMenuOptions}
      />
    </>
  )
}

export default MenuMobile
